import { render, staticRenderFns } from "./fixed_business.vue?vue&type=template&id=0bcfe59a&"
import script from "./fixed_business.vue?vue&type=script&lang=js&"
export * from "./fixed_business.vue?vue&type=script&lang=js&"
import style0 from "./fixed_business.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports